import { CountryCode } from '~/enums';

const updateApplicationMarkets = new Set([CountryCode.SE]);

export const isValidUpdateApplicationMarket = (market: CountryCode) =>
  updateApplicationMarkets.has(market);
